// Client-side pricing config loader.
// Fetches /api/pricing once per session and merges with bundled JSON defaults
// so admin edits propagate without requiring a redeploy.

import bundledConfig from '../config/pricing_config.json';

let cached = null;
let inflight = null;

export function getBundledConfig() {
  return bundledConfig;
}

export async function fetchPricingConfig() {
  if (cached) return cached;
  if (inflight) return inflight;

  inflight = fetch('/api/pricing')
    .then(r => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
    .then(remote => {
      cached = { ...bundledConfig, ...remote };
      return cached;
    })
    .catch(err => {
      console.warn('Falling back to bundled pricing config:', err.message);
      cached = bundledConfig;
      return cached;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export function invalidatePricingCache() {
  cached = null;
}
